<template>
  <div class="container-fluid px-0 bloghome">
    <script type="application/ld+json">
      {
        "@context": "http://schema.org",
        "@graph": [
          {
            "@type": "Article",
            "url": "https://www.teddi.co/blog/",
            "headline": "Recevez les annonces immobilières en premier - Blog",
            "description": "Teddi vous accompagne dans toutes les questions autour de immobilier !",
            "datePublished": "2020-06-10T17:47:50.000Z",
            "dateModified": "2019-06-11T09:20:51.000Z",
            "image": {
              "@type": "ImageObject",
              "url": "https://www.teddi.co/assets/socials/fb-cover.jpg"
            },
            "mainEntityOfPage": {
              "@type": "WebPage",
              "@id": "https://www.teddi.co/blog/"
            },
            "publisher": {
              "@type": "Organization",
              "@id": "https://www.teddi.co/",
              "name": "Pretto",
              "logo": {
                "@type": "ImageObject",
                "url": "https://www.teddi.co/assets/socials/fb-profile.png",
                "width": 1000,
                "height": 1000
              }
            },
            "author": {
              "@type": "Person",
              "name": "Teddi"
            }
          }
        ]
      }
    </script>
    <div class="container px-0">
      <b-row
        class="bg-blue text-white py-5 mt-1 mx-1 mx-md-0 mt-md-0 mb-5 border-radius justify-content-center"
      >
        <h1>Actualités</h1>
      </b-row>
      <b-row align-v="center" class="px-3 mx-1 px-md-0 pb-10">
        <b-col v-for="(post, index) in blogPosts" :key="index" md="4" class="px-2">
          <router-link :to="`/blog/${post.id}`">
            <article>
              <div v-if="post.img">
                <img :alt="post.title" :src="post.img" class="blog-img" />
              </div>
              <h2>{{ post.title }}</h2>
              <div class="text-grey text-left">{{ post.date }}</div>
            </article>
          </router-link>
        </b-col>
        <!-- <button v-if="totalPosts > posts.length" @click="getPosts">
        {{ loading ? "Loading..." : "Voir plus d'articles" }}
      </button> -->
      </b-row>
      <div class="row m-1 justify-content-center text-center py-5">
        <div class="col mx-auto bg-blue text-white text-left border-radius box-shadow">
          <div class="row py-5 justify-content-center align-items-center">
            <div class="col-md-2 d-flex justify-content-center">
              <div>
                <IconStars class="fill-white icon-md" />
              </div>
            </div>
            <div class="col-md-6 d-flex justify-content-center text-center text-md-left my-3">
              <div>
                <h3 class="text-bold mx-0 p-3 p-md-0">
                  Profitez de nos nouveaux services en suivant les étapes de votre parcours
                  immobilier
                </h3>
              </div>
            </div>
            <div class="col-md-2 d-flex justify-content-center">
              <div class="d-flex align-items-center">
                <b-link
                  :to="{ name: 'timeline-buy' }"
                  @click.native="$scrollToTop"
                  class="btn bg-white text-blue text-bold text-uppercase px-4 py-3 my-3 mr-3"
                  >Achat</b-link
                >
                <b-link
                  :to="{ name: 'timeline-rent' }"
                  @click.native="$scrollToTop"
                  class="btn bg-white text-blue text-bold text-uppercase px-4 py-3 my-3"
                  >Location</b-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import BlogPosts from "@/assets/blog/posts.json";
import Footer from "@/components/bottom/Footer.vue";
import IconStars from "@/components/icons/IconStars.vue";

export default {
  components: {
    Footer,
    IconStars,
  },
  metaInfo: {
    title: "Blog",
    titleTemplate: "%s ← Teddi",
    meta: [
      { "http-equiv": "Content-Type", content: "text/html; charset=utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "description",
        content: "Teddi vous accompagne dans toutes les questions autour de l'immobilier !",
      },
      {
        property: "og:title",
        content: "%s ← Teddi",
      },
      { property: "og:site_name", content: "Teddi" },
      { property: "og:type", content: "website" },
      {
        property: "og:url",
        content: "https://www.teddi.co/blog",
      },
      {
        property: "og:image",
        content: "https://www.teddi.co/assets/socials/fb-cover.jpg",
      },
      {
        property: "og:description",
        content: "Teddi vous accompagne dans toutes les questions autour de l'immobilier !",
      },
    ],
    link: [{ rel: "canonical", href: "https://www.teddi.co/blog" }],
  },
  computed: {
    blogPosts() {
      return BlogPosts;
    },
  },
};
</script>
<style lang="scss" scoped>
h2 {
  text-overflow: ellipsis;
  margin-top: 1rem;
  line-height: 26px;
  letter-spacing: 0.2px;
  font-size: 18px;
  overflow: hidden;
  text-align: left;
  color: $body-text;
  font-weight: bold;
}
.blog-img {
  width: 100%;
  border-radius: $radius;
  height: 173px;
  object-fit: contain;
}
</style>
